import * as React from "react";
import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from "../store/index";
import { showResults } from "../reducers/poi";
import { RootState } from "../reducers/index";
import { PoiSearch } from "../api/poisearch";
import { LoadingState } from "../interfaces/loading";
import PoiListResults from "./poilistresults";
import PoiListLoading from "./poilistloading";
import AdthrivePoiList from "./adthrivepoilist";
import PoiListNone from "./poilistnone";

interface IRightResultsProps {
    isLoading: boolean;
}

const RightResults = ({ isLoading }: IRightResultsProps) => {
    const poiList = useAppSelector<Array<PoiSearch>>((x: RootState) => x.poi.list);
    const poiLoading = useAppSelector<LoadingState>((x: RootState) => x.poi.status);

    const ad = <AdthrivePoiList />;
    const poweredby = <div className="powered-by"></div>;

    if (isLoading || poiLoading !== 'succeeded') {
        return (<div>
            <PoiListLoading />
            {ad}
            {poweredby}
        </div>);
    }

    if (poiList.length == 0) {
        return (<div>
            <PoiListNone />
            {ad}
            {poweredby}
        </div>);
    }

    const poisplit = 3;
    if (poiList.length <= poisplit) {
        return (<div>
            <PoiListResults poiList={poiList} />
            {ad}
            {poweredby}
        </div>);
    }
    else {
        const poilist1 = poiList.slice(0, poisplit);
        const poilist2 = poiList.slice(poisplit);

        return (
            <div>
                <PoiListResults poiList={poilist1} />
                {ad}
                <PoiListResults poiList={poilist2} />
                {poweredby}
            </div>
        );
    }

}

export default RightResults;

